// extracted by mini-css-extract-plugin
module.exports = {"item":"ProjectItem-module--item--1cRIB","text":"ProjectItem-module--text--3xdcr"};